import { useMemo } from 'react';
import { SelectArrayInput, SelectArrayInputProps, useTranslate } from 'react-admin';

type SelectArrayInputOrderedChoicesProps = SelectArrayInputProps & { testId?: string };

export function SelectArrayInputOrderedChoices({
  testId,
  ...props
}: SelectArrayInputOrderedChoicesProps) {
  const { choices, ...rest } = props;
  const translate = useTranslate();
  const sortedChoices = useMemo(
    () =>
      choices?.sort((a, b) => {
        const translatedA = translate(a.name);
        const translatedB = translate(b.name);
        return translatedA.localeCompare(translatedB);
      }),
    [choices, translate],
  );

  return <SelectArrayInput choices={sortedChoices} {...rest} data-testid={testId} />;
}
